import { CloudCode } from './cloudcode';

export interface BusinessBarberObj {
  id: string;
  active: boolean;
  completedOnboarding: boolean;
  averageRating: number;
  numRatings: number;
  fullName: string;
  firstName: string;
  lastName: string;
  isoPhoneNumber: string;
  nationalPhoneNumber: string;
  startingPrice: number;
  pic: string;
  link: string;
  serviceIDs: string[];
  servicePricing: any;
  proType: string;
  currency: string;

  // Pros list page (SCC)
  numCompletedAppts: number;
  numClientsInvited: number;
  numReferredClients: number;
  numProStoreOrders: number;
  numPromosCreated: number;
  numAutoSchedMinutes: number;
  serviceTitles: string[];

  // Pro profile (SCC)
  vip: boolean;
  bio: string;
  email: string;
  address: string;
  createdAt: Date;
  device: string;
  proCommissionTier: string;
  proCommissionTierRatio: number;

  // Pro settings (SCC)
  acceptingPinRequests: boolean;
  acceptingOutOfRangeRequests: boolean;
  minimumTravelTime: number;
  disableAutoProChats: boolean;
  deprioritizeProfileInFeed: boolean;
  lockServicesAndPricing: boolean;
  businessCommissionID: string;
}

export interface OverallAnalytics {
    numAppts: number;
    revenueTotal: number;
    businessCommissionTotal: number;
    tipTotal: number;
    currency: string;
}

export interface ProSummary {
    info: BusinessBarberObj;
    earnings: number;
    tips: number;
    numAppts: number;
    numHoursWorked: number;
}

export class BusinessAnalyticsTasks {

  static pullAggregateBusinessProReport(
    startDate: Date,
    endDate: Date,
    optBusinessLocationID: string,
    successCallback: (overallAnalytics: OverallAnalytics, proSummaries: ProSummary[]) => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('pullAggregateBusinessProReport',
      {
        startDate: startDate,
        endDate: endDate,
        optBusinessLocationID: optBusinessLocationID,
      },
      (rsp: {overallAnalytics: OverallAnalytics, proSummaries: ProSummary[]}) => {
        successCallback(rsp.overallAnalytics, rsp.proSummaries);
      },
      (msg: string) => {
        errorCallback(msg);
      });
  }

  static generateBusinessProPaymentsPDF(
    startDate: Date,
    endDate: Date,
    successCallback: (url: string) => void,
    errorCallback: (msg: string) => void) {

    const timezoneOffset = (new Date()).getTimezoneOffset();

    CloudCode.run('generateBusinessProPaymentsPDF',
      {
        startDate: startDate,
        endDate: endDate,
        timezoneOffset: timezoneOffset,
        // optBusinessLocationID: optBusinessLocationID, // unimplemented on server
      },
      (url: string) => {
        successCallback(url);
      },
      (msg: string) => {
        errorCallback(msg);
      });
  }

}